<template>
  <div class="donate-page">
    <section class="donate-hero">
      <div class="hero-content">
        <p class="hero-subtitle">
          如果 CarDesignSpace 曾帮助你找到灵感、整理资料或发现好设计，欢迎用一杯咖啡支持我们继续维护这个社区。
        </p>
      </div>
    </section>

    <main class="donate-content">
      <section class="donate-card">
        <div class="donate-info">
          <h2>你的支持会用于</h2>
          <div class="support-list">
            <div class="support-item">
              <i class="el-icon-picture-outline"></i>
              <div>
                <h3>图片资料整理</h3>
                <p>持续收集、校对和维护高质量汽车设计图片与标签。</p>
              </div>
            </div>
            <div class="support-item">
              <i class="el-icon-cpu"></i>
              <div>
                <h3>服务器与存储成本</h3>
                <p>保障图片浏览、搜索、上传和社区功能稳定运行。</p>
              </div>
            </div>
            <div class="support-item">
              <i class="el-icon-magic-stick"></i>
              <div>
                <h3>新功能开发</h3>
                <p>继续打磨智能搜索、灵感收藏和设计社区体验。</p>
              </div>
            </div>
          </div>
        </div>

        <aside class="donate-panel">
          <div class="donate-qr">
            <img
              :src="donationQrUrl"
              alt="CarDesignSpace 收款码"
              class="donate-qr-image"
            />
          </div>
          <h2>扫码支持</h2>
          <p>
            使用微信或支付宝扫码，支持 CarDesignSpace 持续维护和更新。
          </p>
          <el-button type="primary" class="contact-button" @click="$router.push('/about')">
            联系我们
          </el-button>
        </aside>
      </section>

      <section class="thanks-section">
        <h2>感谢每一份支持</h2>
        <p>
          CarDesignSpace 是一个因热爱而聚集的项目。你的支持会帮助我们把它维护得更稳定、更好用，也让更多设计爱好者受益。
        </p>
      </section>
    </main>
  </div>
</template>

<script>
export default {
  name: 'Donate',
  computed: {
    donationQrUrl() {
      return '/api/cos-asset/%E4%BA%8C%E7%BB%B4%E7%A0%81/%E6%94%B6%E6%AC%BE%E7%A0%81.jpg?v=20260709'
    }
  },
  mounted() {
    document.title = '赞助支持 - CarDesignSpace'
  }
}
</script>

<style scoped>
.donate-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;
}

.donate-hero {
  position: relative;
  overflow: hidden;
  padding: 40px 20px;
  color: #fff;
  text-align: center;
  background: linear-gradient(135deg, #000 0%, #1a1a1a 100%);
}

.donate-hero::before {
  content: '';
  position: absolute;
  inset: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grid" width="10" height="10" patternUnits="userSpaceOnUse"><path d="M 10 0 L 0 0 0 10" fill="none" stroke="rgba(255,255,255,0.1)" stroke-width="0.5"/></pattern></defs><rect width="100" height="100" fill="url(%23grid)"/></svg>');
  opacity: 0.3;
}

.hero-content {
  position: relative;
  z-index: 1;
  max-width: 780px;
  margin: 0 auto;
}

.hero-subtitle {
  max-width: 680px;
  margin: 0 auto;
  color: rgba(255, 255, 255, 0.9);
  font-size: 19px;
  font-weight: 300;
  line-height: 1.7;
}

.donate-content {
  max-width: 1180px;
  margin: 0 auto;
  padding: 60px 20px;
}

.donate-card {
  display: grid;
  grid-template-columns: minmax(0, 1.4fr) minmax(320px, 0.8fr);
  gap: 32px;
  align-items: stretch;
}

.donate-info,
.donate-panel,
.thanks-section {
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 20px;
}

.donate-info {
  padding: 44px;
}

.donate-info h2,
.donate-panel h2,
.thanks-section h2 {
  margin: 0;
  color: #333;
  font-size: 28px;
  font-weight: 700;
}

.support-list {
  display: grid;
  gap: 24px;
  margin-top: 32px;
}

.support-item {
  display: flex;
  gap: 18px;
  padding: 24px;
  border-radius: 16px;
  background: linear-gradient(135deg, #f8f9fa 0%, #eef0f2 100%);
  transition: transform 0.3s ease;
}

.support-item:hover {
  transform: translateY(-4px);
}

.support-item i {
  flex: 0 0 auto;
  color: #e03426;
  font-size: 30px;
}

.support-item h3 {
  margin: 0 0 8px;
  color: #333;
  font-size: 20px;
}

.support-item p {
  margin: 0;
  color: #666;
  font-size: 15px;
  line-height: 1.7;
}

.donate-panel {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 38px 30px;
  text-align: center;
}

.donate-qr {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 220px;
  height: 220px;
  margin-bottom: 26px;
  border-radius: 18px;
  background: #fff;
  border: 1px solid #f0f0f0;
  overflow: hidden;
}

.donate-qr-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.donate-panel p {
  margin: 14px 0 24px;
  color: #666;
  font-size: 15px;
  line-height: 1.7;
}

.contact-button {
  min-width: 140px;
  background: #e03426;
  border-color: #e03426;
}

.thanks-section {
  margin-top: 32px;
  padding: 42px;
  text-align: center;
}

.thanks-section p {
  max-width: 760px;
  margin: 16px auto 0;
  color: #666;
  font-size: 16px;
  line-height: 1.8;
}

@media (max-width: 900px) {
  .donate-card {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .donate-hero {
    padding: 32px 18px;
  }

  .hero-subtitle {
    font-size: 17px;
  }

  .donate-content {
    padding: 40px 15px;
  }

  .donate-info,
  .donate-panel,
  .thanks-section {
    padding: 28px 20px;
  }

  .support-item {
    padding: 20px;
  }
}

@media (max-width: 480px) {
  .hero-subtitle {
    font-size: 15px;
  }

  .support-item {
    flex-direction: column;
  }

  .donate-qr {
    width: 180px;
    height: 180px;
  }
}

/* ===== 资料库风格配色覆盖 ===== */
.donate-page {
  min-height: calc(100vh - 60px);
  color: #171511;
  background:
    linear-gradient(90deg, rgba(224, 52, 38, 0.045) 0 1px, transparent 1px),
    linear-gradient(180deg, rgba(224, 52, 38, 0.035) 0 1px, transparent 1px),
    #f6f4ee;
  background-size: 56px 56px;
}

.donate-hero {
  padding: 34px 20px;
  color: #171511;
  background: transparent;
}

.donate-hero::before {
  display: none;
}

.hero-content {
  max-width: 1180px;
  padding: 30px 36px;
  background: rgba(255, 253, 248, 0.94);
  border: 1px solid #29251f;
}

.hero-subtitle {
  color: #70695e;
  font-weight: 500;
}

.donate-content {
  padding: 28px 20px 52px;
}

.donate-info,
.donate-panel,
.thanks-section,
.support-item {
  background: #fffdf8;
  border: 1px solid #d9d3c6;
  border-radius: 0;
  box-shadow: none;
}

.support-item {
  background: #faf8f0;
}

.support-item:hover {
  border-color: #e03426;
  transform: translateY(-2px);
}

.donate-info h2,
.donate-panel h2,
.thanks-section h2,
.support-item h3 {
  color: #171511;
  font-weight: 900;
  letter-spacing: -0.03em;
}

.support-item p,
.donate-panel p,
.thanks-section p {
  color: #70695e;
}

.support-item i {
  color: #e03426;
}

.donate-qr {
  background: #fffdf8;
  border: 1px solid #29251f;
  border-radius: 0;
}

.contact-button {
  color: #fff;
  background: #e03426;
  border-color: #e03426;
  border-radius: 0;
  box-shadow: none;
}

.contact-button:hover {
  background: #f04838;
  border-color: #f04838;
}

/* ===== 版面最终优化：统一左右边距与边框节奏 ===== */
.donate-page {
  --page-max-width: 1180px;
  --page-gutter: 24px;
}

.donate-hero,
.donate-content {
  width: 100%;
  max-width: calc(var(--page-max-width) + var(--page-gutter) * 2);
  margin: 0 auto;
  padding-right: var(--page-gutter);
  padding-left: var(--page-gutter);
  box-sizing: border-box;
}

.donate-hero {
  padding-top: 34px;
  padding-bottom: 0;
}

.donate-content {
  max-width: calc(var(--page-max-width) + var(--page-gutter) * 2);
  padding-top: 0;
  padding-bottom: 56px;
}

.hero-content {
  max-width: none;
  width: 100%;
  margin: 0;
  padding: 36px 42px;
  box-sizing: border-box;
}

.hero-subtitle {
  max-width: 820px;
  margin: 0;
  text-align: left;
}

.donate-card {
  display: grid;
  grid-template-columns: minmax(0, 1.45fr) minmax(300px, 0.75fr);
  gap: 0;
  width: 100%;
  margin: 0;
  border-right: 1px solid #d9d3c6;
  border-left: 1px solid #d9d3c6;
  border-bottom: 1px solid #d9d3c6;
}

.donate-info,
.donate-panel {
  border: none;
}

.donate-info {
  padding: 42px;
  border-right: 1px solid #d9d3c6;
}

.donate-panel {
  padding: 42px 34px;
}

.support-list {
  gap: 0;
  margin-top: 28px;
  border: 1px solid #d9d3c6;
}

.support-item {
  border: none;
  border-bottom: 1px solid #d9d3c6;
}

.support-item:last-child {
  border-bottom: none;
}

.thanks-section {
  margin-top: 0;
  padding: 36px 42px;
  text-align: left;
  border-top: none;
}

.thanks-section p {
  max-width: 820px;
  margin-right: 0;
  margin-left: 0;
}

@media (max-width: 900px) {
  .donate-card {
    grid-template-columns: 1fr;
  }

  .donate-info {
    border-right: none;
    border-bottom: 1px solid #d9d3c6;
  }
}

@media (max-width: 768px) {
  .donate-page {
    --page-gutter: 16px;
  }

  .hero-content,
  .donate-info,
  .donate-panel,
  .thanks-section {
    padding: 24px 20px;
  }
}

/* 收敛赞助页背景层级，避免纯白卡片与米色页面割裂。 */
.donate-page {
  --donate-paper: #fbf7ee;
  --donate-soft: #f1ecdf;
  --donate-line: #d9d3c6;
}

.hero-content,
.donate-info,
.donate-panel,
.thanks-section {
  background: var(--donate-paper) !important;
}

.support-list,
.support-item,
.donate-qr {
  background: var(--donate-soft) !important;
}

.donate-card,
.support-list,
.support-item,
.thanks-section {
  border-color: var(--donate-line) !important;
}

.donate-qr {
  border-color: #29251f !important;
}

/* 首页同款轻纸面：去掉赞助页硬边框线条，靠背景层级区分内容。 */
.donate-page {
  --donate-paper: rgba(255, 253, 248, 0.72);
  --donate-soft: rgba(238, 236, 227, 0.76);
}

.hero-content,
.donate-card,
.donate-info,
.donate-panel,
.support-list,
.support-item,
.thanks-section,
.donate-qr {
  border: none !important;
  box-shadow: none !important;
}

.hero-content,
.donate-info,
.donate-panel,
.thanks-section {
  background: var(--donate-paper) !important;
}

.support-list,
.support-item,
.donate-qr {
  background: var(--donate-soft) !important;
}

.support-item:hover {
  background: rgba(224, 52, 38, 0.08) !important;
  transform: none !important;
}

/* 赞助页文案间距微调。 */
.donate-page .hero-content {
  padding-bottom: 18px !important;
}

.donate-page .hero-subtitle {
  line-height: 1.55 !important;
}

.donate-page .donate-info {
  padding-top: 30px !important;
}

.donate-page .thanks-section {
  padding-top: 22px !important;
}
</style>
